<div class="generalPage" aria-label="help-pending content" role="main" *ngIf="outcome">
  <div class="pr-22 content-container pb-0 print-all-content" [ngClass]="IsRightPanel?'pt-0 pb-1-5rem-imp':''">
    <h1 class="generalHeader margin-0 content-blue bold itcHeavyFont pb-heading" role="heading">{{pd_heading}}</h1>
    <p class="answer font-16 content-blue width-100 pb-heading" [innerHTML]="pd_para1" [ngClass]="IsRightPanel?'pt-1':'pt-0-5'"></p>
    <img alt="Help_PCS" class="width-80" [src]="imageURL" />
    <p class="answer font-16 content-blue width-100 pb-heading mt-2" [innerHTML]="pd_para1_2"></p>
    <p class="answer font-24 content-blue width-100 mb-invert-12 bold pb-heading" role="heading">{{pd_para2heading_1}}</p>
    <p class="answer font-16 content-blue width-100 pb-heading" [innerHTML]="pd_para2heading_1_desc"></p>
    <p class="answer font-24 content-blue width-100 mb-invert-12 bold pb-heading" role="heading">{{pcs_heading}}</p>
    <p class="answer font-16 content-blue width-100 pb-heading" [innerHTML]=" pcs_BodyPreDesc"></p>
    <p *ngIf="Isnotloginpage" class="answer font-16 content-blue width-100 pb-heading">
      <span>{{content1TC}}</span><span class="highlight-blue border-bottom-help cursor-pointer" (click)="showTC()">{{content2TC}}</span><span (click)="openLinkbyId($event)" [innerHTML]="content3TC"></span>
    </p>
    <p class="answer font-16 content-blue width-100 pb-heading" [innerHTML]="pcs_BodyDesc"></p>
    <div *ngIf="Isnotloginpage" class="flex-display print-content-hide">
      <button mat-button class="btn-primary-action-add" (click)="acceptTC()">Start</button>
    </div>
  </div>
</div>
